module.exports = __webpack_public_path__ + "static/img/pg.e15d7e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/pg.png
// module id = xtmJ
// module chunks = 18